import {
  drawerWidth,
  transition,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  blackColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react.jsx";
import { ourOrange  } from 'assets/jss/incept-sustainability-variables.jsx';

const sidebarStyle = (theme) => ({
  drawerPaper: {
    border: "none",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
    // ...boxShadow,
    width: drawerWidth,
    overflowX: "hidden",
    [theme.breakpoints.up("md")]: {
      height: "100%",
    },
    [theme.breakpoints.down('md')]: {
      ...boxShadow,
      /*display: "block",*/
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      zIndex: "1032",
      visibility: "visible",
      overflowY: "scroll",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
  },
  drawerPaperRTL: {
    [theme.breakpoints.up("md")]: {
      left: "auto !important",
      right: "0 !important",
    },
    [theme.breakpoints.down('md')]: {
      left: "0  !important",
      right: "auto !important",
    },
  },
  logo: {
    zIndex: "4",
    position:"relative",
    paddingBottom:"15px",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "0",
      height: "1px",
      right: "15px",
      width: "calc(100% - 30px)",
      backgroundColor: "rgba(" + hexToRgb(grayColor[6]) + ", 0.3)",
    },
  },
  logoIncept:{
    marginTop:'auto',
    paddingBottom:'40px'
  },
  logoLink: {
    ...defaultFont,
    textTransform: "uppercase",
    padding: "5px 0",
    display: "block",
    fontSize: "18px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "60px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": {
      color: whiteColor,
    },
  },
  logoImage: {
    width: "60%",
    display: "inline-block",
    marginTop: "20px"
  },
  logoImage2: {
    width: "50%",
    maxHeight: "60px",
    marginLeft: "10px",
    marginRight: "15px",
    display: "flex",
    alignItems: "flex-end",
  },
  img: {
    bottom: "22px",
    zIndex: "5",
  },
  imgBottom: {
    width: "110px",
    "@media only screen and (max-width: 1280px)": {
      width: "70px",
    }
  },
  loanApplicationLink: {
    backgroundColor: "transparent",
    borderRadius: "10px",
    marginLeft: '29px',
    marginBottom: '10px',
    padding: "10px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F7F6F3",
    },
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      opacity: ".8",
    },
  },
  list: {
    paddingLeft: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none",
    position: "unset",
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none !important",
    "&:hover,&:focus,&:visited,&": {
      color: "blue",
    },
  },
  itemLink: {
    width: drawerWidth,
    color: whiteColor,
    transition: "all 300ms linear",
    margin: "10px 0",
    borderRadius: "2rem",
    position: "relative",
    left: "1.3rem",
    backgroundColor: "whiteColor",
    display: "block",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: grayColor[12],
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#F7F6F3"
    },
    ...defaultFont,
  },
  itemIcon: {
    height: "25px",
    marginRight: "10px",
  },
  itemIcon2: {
    height: "20px",
    marginRight: "10px",
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    lineHeight: "30px",
    fontSize: "14px",
    color: "black",
    fontWeight: "400",
  },
  whiteFont: {
    color: "",
  },
  purple: {
    backgroundColor: primaryColor[0],
    ...primaryBoxShadow,
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow,
    },
  },
  blue: {
    backgroundColor: "#F7F6F3",
    "&:hover,&:focus": {
      backgroundColor: "#F7F6F3",
    },
  },
  subMenu: {
    "& div":{
      fontWeight: "700",
      textDecoration: "underline"
    }
  },
  menuArrow: {
    color: ourOrange,
    marginRight: "25px"
  },
  showMenu: {
    display: "flex"
  },
  hideMenu: {
    display: "none !important"
  },
  showMenuKB: {
    display: "flex"
  },
  hideMenuKB: {
    display: "none !important"
  },
  green: {
    backgroundColor: successColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(successColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(successColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: successColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(successColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(successColor[0]) +
        ",.2)",
    },
  },
  orange: {
    backgroundColor: warningColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: warningColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.2)",
    },
  },
  red: {
    backgroundColor: dangerColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: dangerColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.2)",
    },
  },
  sidebarWrapper: {
    position: "relative",
    //height: "60vh",
    overflow: "visible",
    width: "220px",
    zIndex: "4",
    overflowScrolling: "touch",
  },
  activePro: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "100%",
      bottom: "13px",
    },
  },
  nestedHover: {
    '&:hover': {
        backgroundColor: 'red', // Use theme.palette for color if available
    },
  },
});

export default sidebarStyle;
